/**
 *
 * Disclaimer: Source code mentioned below is(are) Intellectual Property of
 * Crayon Data Holdings Limited (including its subsidiaries and affiliates).
 * Crayon Data Holdings Limited reserves right to own and control it the way
 * it may deem fit. You must refrain from use, access, read, modify, add or
 * delete, sell or use in any other package or programme pertaining to such
 * source code without explicit prior written approval of
 * Crayon Data Holding Limited. Breach of the same shall attract penalty as
 * applicable.
 *
 */

// CardCarousel Component
import React, { Component } from "react";
import HeartUnFilled from "../../assets/img/heartunfillednew.png";
import HeartFilled from "../../assets/img/heart_new_fillednew.png";
import uiConfig from "../../uiConfig";
import {
  formatDateProfileMonth,
  dayDifference,
  hourDifference,
  formatDayHour,
  formatTimeHourMinute,
  formatDateProfileMonthArabic,
  truncateStr,
  toTitleCase
} from "../../pages/helper";
import GaugeChart from "react-gauge-chart";
import { interaction, getError, checkColor, tobase64 } from "../../service";
import arrowRight from "../../assets/img/arrowRight.png";
import warningTriangle from "../../assets/img/warning-triangle.svg";
import arrowRightBlue from "../../assets/img/arrowRightBlue.png";
// import Color from "color-thief-react";
import { arabicTempText } from "../../constants";
// import fetch from "fetch-base64"
import config from "../../service/config";
import Icon from "../Icons";
//Import Config
var MatomoTracker = require("matomo-tracker");
var matomo = new MatomoTracker(config.siteId, config.siteURL);

export default class NewCard extends Component {
  state = {
    imgSrc: "",
    loading: false,
    width: 0,
    isArrowDisplayed: false
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  _onClick = (e, item, choiceId) => {
    // localStorage.setItem("itemtype" , item.itemType )
    // localStorage.setItem("itemid" , item.id )
    e.preventDefault();
    const {
      history,
      searchItem,
      listName,
      onChangeTab,
      title,
      category,
      filterData
    } = this.props;
    const pathname =
      listName === "similar"
        ? "home"
        : this.props.history.location.pathname.split("/").slice(1)[1];
    sessionStorage.setItem("activeMenu", pathname);
    if (history) {
      if (searchItem) {
        history.push(
          `/home/merchant/${item.id}`,
          { from: searchItem },
          { state: onChangeTab }
        );
      } else if (
        this.props.from !== undefined &&
        this.props.from === "wishlisted" &&
        item.active === false
      ) {
        return;
      } else {
        if (this.props.history.location?.pathname?.includes("home/merchant")) {
          // let merObject = { 'id': item.id, 'name': item?.name };
          // sessionStorage.setItem('prevMerchant', JSON.stringify(merObject));
          history.push(`/home/merchant/${item.id}`, {
            merchantName: item?.name,
            page: "similarItem"
          });
        } else if (
          this.props.history.location?.pathname?.includes("home/wishlisted")
        ) {
          history.push(`/home/merchant/${item.id}`, {
            from: "wishlist",
            merchantName: item?.name
          });
        } else if (category) {
          history.push(`/home/merchant/${item.id}`, {
            from: "home",
            category: { category },
            filterData: { filterData }
          });
        } else {
          history.push(`/home/merchant/${item.id}`, {
            from: "home",
            itemtype: { item }
          });
        }
      }
      window.scrollTo(0, 0);
    }
    if (this.props.checkColor) {
      this.props.checkColor();
    }
    matomo.track({
      url: window.location.href,
      e_c: item.category,
      e_a: "VIEW_MERCHANT",
      e_n: item.id
    });
    if (title) {
      matomo.track({
        url: window.location.href,
        e_c: title,
        e_a: "LIST_CLICK",
        e_n: item.id
      });
    }
    localStorage.setItem("merchantDL", "true");
    localStorage.setItem("from", "merchantPage");
    if (this.props.filter) {
      localStorage.setItem("filter", JSON.stringify(this.props.filter));
    }
    if (this.props.selected) {
      localStorage.setItem(
        "selectedOption",
        JSON.stringify(this.props.selected)
      );
    }
    if (this.props.currentPage) {
      localStorage.setItem("currentpage", this.props.currentPage);
    }
  };

  userInteraction = (e, itemId, type, imgId) => {
    e.stopPropagation();
    e.preventDefault();
    var imgSrc = document.getElementById(imgId).getAttribute("data");
    let wishListLike = JSON.parse(localStorage.getItem("allOffers-wishlist"));
    if (imgSrc == "UNDO_WISHLIST") {
      if (localStorage.getItem("USERID") === null) {
        this.props._openLogin();
        localStorage.setItem("interactionType", "WISHLIST");
        localStorage.setItem("interactionId", itemId);
      }
      if (localStorage.getItem("USERID")) {
        document.getElementById(imgId).setAttribute("data", "WISHLIST");
        document.getElementById(imgId).src = HeartFilled;
        if (this.props.item.itemType === "PORTFOLIO_OFFERS") {
          interaction("WISHLIST", "PORTFOLIO_OFFERS", itemId)
            .then((res) => {
              if (this.props.category === "all offers") {
                wishListLike.push(itemId);
                localStorage.setItem(
                  "allOffers-wishlist",
                  JSON.stringify(wishListLike)
                );
              }
            })
            .catch((err) => {
              if (err && err.data && err.data.status === 404) {
              } else {
                //    console.log(getError(err));
              }
            });
          matomo.track({
            url: window.location.href,
            e_c: this.props.item.category,
            e_a: "WISHLIST",
            e_n: itemId
          });
        } else if (this.props.item.itemType === "FINANCIAL_PRODUCT") {
          interaction("WISHLIST", "FINANCIAL_PRODUCT", itemId)
            .then((res) => {
              if (this.props.category === "all offers") {
                wishListLike.push(itemId);
                localStorage.setItem(
                  "allOffers-wishlist",
                  JSON.stringify(wishListLike)
                );
              }
            })
            .catch((err) => {
              if (err && err.data && err.data.status === 404) {
              } else {
                //    console.log(getError(err));
              }
            });
          matomo.track({
            url: window.location.href,
            e_c: this.props.item.category,
            e_a: "WISHLIST",
            e_n: itemId
          });
        } else {
          interaction("WISHLIST", "MERCHANT", itemId)
            .then((res) => {
              if (this.props.category === "all offers") {
                wishListLike.push(itemId);
                localStorage.setItem(
                  "allOffers-wishlist",
                  JSON.stringify(wishListLike)
                );
              }
            })
            .catch((err) => {
              if (err && err.data && err.data.status === 404) {
              } else {
                //    console.log(getError(err));
              }
            });
          matomo.track({
            url: window.location.href,
            e_c: this.props.item.category,
            e_a: "WISHLIST",
            e_n: itemId
          });
        }
      }
    } else {
      document.getElementById(imgId).setAttribute("data", "UNDO_WISHLIST");
      document.getElementById(imgId).src = HeartUnFilled;
      if (this.props.item.itemType === "PORTFOLIO_OFFERS") {
        interaction("UNDO_WISHLIST", "PORTFOLIO_OFFERS", itemId)
          .then((res) => {
            if (this.props.updatewishlistData) {
              this.props.updatewishlistData();
            }

            if (this.props.category === "all offers") {
              let removeArr = wishListLike.filter((e) => e !== itemId);

              localStorage.setItem(
                "allOffers-wishlist",
                JSON.stringify(removeArr)
              );
            }
          })

          .catch((err) => {
            if (err && err.data && err.data.status === 404) {
            } else {
              //    console.log(getError(err));
            }
          });
      } else if (this.props.item.itemType === "FINANCIAL_PRODUCT") {
        interaction("UNDO_WISHLIST", "FINANCIAL_PRODUCT", itemId)
          .then((res) => {
            if (this.props.updatewishlistData) {
              this.props.updatewishlistData();
            }
            if (this.props.category === "all offers") {
              let removeArr = wishListLike.filter((e) => e !== itemId);
              localStorage.setItem(
                "allOffers-wishlist",
                JSON.stringify(removeArr)
              );
            }
          })
          .catch((err) => {
            if (err && err.data && err.data.status === 404) {
            } else {
              //    console.log(getError(err));
            }
          });
        matomo.track({
          url: window.location.href,
          e_c: this.props.item.category,
          e_a: "WISHLIST",
          e_n: itemId
        });
      } else {
        interaction("UNDO_WISHLIST", "MERCHANT", itemId)
          .then((res) => {
            if (this.props.updatewishlistData) {
              this.props.updatewishlistData();
            }
            if (this.props.category === "all offers") {
              let removeArr = wishListLike.filter((e) => e !== itemId);
              localStorage.setItem(
                "allOffers-wishlist",
                JSON.stringify(removeArr)
              );
            }
          })
          .catch((err) => {
            if (err && err.data && err.data.status === 404) {
            } else {
              //    console.log(getError(err));
            }
          });
        matomo.track({
          url: window.location.href,
          e_c: this.props.item.category,
          e_a: "UNDO_WISHLIST",
          e_n: itemId
        });
      }
    }
  };

  displayArrow = (val) => {
    this.setState({
      isArrowDisplayed: val
    });
  };

  //  componentWillReceiveProps(nextProps){
  //    if(nextProps.item.properties.url){
  //      this.checkColor()
  //    }
  //  }

  // Date
  renderDateField(date) {
    let formattedDate;

    if (hourDifference(date) < 24) {
      formattedDate = `${formatTimeHourMinute(date)}`;
    } else if (dayDifference(date) < 2) {
      formattedDate = `${formatDayHour(date)}`;
    } else if (dayDifference(date) <= 30) {
      formattedDate = `${dayDifference(date)} days`;
    } else if (dayDifference(date) > 30) {
      formattedDate = formatDateProfileMonth(date);
    }

    return formattedDate;
  }

  /* Main Render Functions */
  render() {
    const lang = localStorage.getItem("language");
    const { item, itemId, wishlisted, listName, cardminLength, listType } =
      this.props;
    const { loading, imgSrc, isArrowDisplayed, width } = this.state;

    let txtLen = width > 800 ? 35 : 40;
    let titleLen = 50;
    if (window.matchMedia("(min-width: 1900px)").matches) {
      // check screen size and alter txtlen accordingly
      txtLen = 50;
      titleLen = 60;
    } else if (window.matchMedia("(min-width: 1700px)").matches) {
      // check screen size and alter txtlen accordingly
      txtLen = 50;
      titleLen = 50;
    } else if (window.matchMedia("(min-width: 1600px)").matches) {
      // check screen size and alter txtlen accordingly
      txtLen = uiConfig.config.whitelabel.clientName === "hdfc" ? 30 : 38;
      titleLen = 45;
    } else if (window.matchMedia("(min-width: 1500px)").matches) {
      txtLen = uiConfig.config.whitelabel.clientName === "hdfc" ? 30 : 38;
      titleLen = 40;
    } else if (window.matchMedia("(min-width: 1400px)").matches) {
      txtLen = 48;
      titleLen = 50;
    } else if (window.matchMedia("(min-width: 1200px)").matches) {
      txtLen = 37;
      titleLen = 45;
    } else if (window.matchMedia("(min-width: 1000px)").matches) {
      txtLen = 32;
      titleLen = 45;
    } else if (window.matchMedia("(min-width: 768px)").matches) {
      txtLen = 32;
      titleLen = 40;
    }

    return (
      <>
        {!loading && (
          <div
            style={{
              marginRight:
                this.state.width < 800 && this.props.lastCard && item.offers.length > 1  ? "15px" : "0px"
            }}
            // style={{margin:"20px 20px 20px 0px"}}
          >
            <a
              className="new-card-div"
              id={"mycard_" + itemId}
              onMouseOver={() => this.displayArrow(true)}
              onMouseOut={() => this.displayArrow(false)}
              href={`/home/merchant/${item.id}`}
              onClick={(e) => this._onClick(e, item, itemId)}
            >
              <div className={width > 768 ? "new_card" : "new_card mbl"}>
                <a key={`${item.id}-${itemId}`} className="content">
                  {
                    this.props.isWishlistedComponent ? (
                      <div
                        className={
                          lang === "AR"
                            ? "card_carousel_heartImgDivArab"
                            : "card_carousel_heartImgDiv"
                        }
                      >
                        <img
                          src={HeartFilled}
                          width={width > 800 ? 21 : 18}
                          height={width > 800 ?18 :16}
                          className="card_carousel_heartImg"
                          style={{ cursor: "pointer" }}
                          onClick={(e) =>
                            this.props.userInteraction(
                              e,
                              item.id,
                              "UNDO_WISHLIST"
                            )
                          }
                          id={item.id}
                          data="UNDO_WISHLIST"
                        />
                      </div>
                    ) : (
                      <div
                        className={
                          lang === "AR"
                            ? "card_carousel_heartImgDivArab"
                            : "card_carousel_heartImgDiv"
                        }
                      >
                        {wishlisted ? (
                          <img
                            src={HeartFilled}
                            width={width > 800 ? 21 : 18}
                          height={width > 800 ?18 :16}
                            className="card_carousel_heartImg"
                            onClick={(e) =>
                              this.userInteraction(
                                e,
                                item.id,
                                "UNDO_WISHLIST",
                                listName + "-" + item.id
                              )
                            }
                            id={listName + "-" + item.id}
                            data="WISHLIST"
                          />
                        ) : (
                          <img
                            src={HeartUnFilled}
                            width={width > 800 ? 21 : 18}
                          height={width > 800 ?18 :16}
                            className="card_carousel_heartImg"
                            onClick={(e) =>
                              this.userInteraction(
                                e,
                                item.id,
                                "WISHLIST",
                                listName + "-" + item.id
                              )
                            }
                            id={listName + "-" + item.id}
                            data="UNDO_WISHLIST"
                          />
                        )}
                      </div>
                    )
                    /* } */
                  }
                  <div
                    className={lang === "AR" ? "col-lft-ar" : "col-lft"}
                    style={
                      this.props.from !== undefined &&
                      this.props.from === "wishlisted" &&
                      item.active === false &&
                      uiConfig.config.whitelabel.components.merchant_card
                        .offer_type
                        ? uiConfig.config.whitelabel.components.merchant_card
                            .expiry_offer_type
                        : uiConfig.config.whitelabel.components.merchant_card
                            .offer_type
                        ? uiConfig.config.whitelabel.components.merchant_card
                            .offer_type
                        : {}
                    }
                  >
                    {item.itemType === "FINANCIAL_PRODUCT"
                      ?
                        item.merchantType.length === 2
                        ? `Bank & Online + Instore`
                        : item.merchantType[0] === "online"
                        ? `Bank & Online`
                        : `Bank & Instore`
                      :
                     item.merchantType.length === 2
                      ? `Online + Instore`
                      : item.merchantType[0] === "online"
                      ? `Online`
                      : `Instore`}
                  </div>
                  <div
                    className={`${
                      this.props.from !== undefined &&
                      this.props.from === "wishlisted" &&
                      item.active === false &&
                      "offerExp"
                    } imagediv`}
                  >
                    <img
                      src={`${config.optimoleURL}/w:320/h:200/q:85/rs:fit/${
                        item.properties?.curatedImage
                          ? item.properties?.curatedImage
                          : item.properties?.image
                      }`}
                      width="100%"
                    ></img>
                  </div>
                  {/* <div className={`img-content`} style={{ padding: "0px"}}>
                  {this.props.isWishlistedComponent ?
                    <div className={lang === "AR" ? "card_carousel_heartImgDivArab" : "card_carousel_heartImgDiv"}>
                      <img src={HeartFilled} width={21} height={18} className="card_carousel_heartImg" style={{ cursor: "pointer" }} onClick={(e) => this.props.userInteraction(e, item.id, "UNDO_WISHLIST")} id={item.id} data="UNDO_WISHLIST" />
                    </div>
                    :
                    <div className={lang === "AR" ? "card_carousel_heartImgDivArab" : "card_carousel_heartImgDiv"}>
                      {
                        wishlisted ?
                          <img src={HeartFilled} width={21} height={18} className="card_carousel_heartImg" onClick={(e) => this.userInteraction(e, item.id, "UNDO_WISHLIST", listName + "-" + item.id)} id={listName + "-" + item.id} data="WISHLIST" />
                          :
                          <img src={HeartUnFilled} width={21} height={18} className="card_carousel_heartImg" onClick={(e) => this.userInteraction(e, item.id, "WISHLIST", listName + "-" + item.id)} id={listName + "-" + item.id} data="UNDO_WISHLIST" />
                      }
                    </div>
                    /*
                  }
                  <div className={lang === "AR" ? "col-lft-ar" : "col-lft"} style={uiConfig.config.whitelabel.components.merchant_card.offer_type ? uiConfig.config.whitelabel.components.merchant_card.offer_type : {}}>
                    {item.isOnline ? lang === "AR" ? arabicTempText.online : "Online" : lang === "AR" ? arabicTempText.instore : "Instore"}
                  </div>
                  {uiConfig.config.whitelabel.clientName === "hdfc" && listType === "NEAR_BY" ?
                      // <div className="title-ins" style={{ color: uiConfig?.config?.whitelabel?.components?.merchant_card?.cardTitleColor }} title={item.name} >{ truncateStr(item.name , titleLen) }</div> 
      
                      <div className="card-image"
                        style={{
                          backgroundColor: item.properties.dominantColorCode
                            ? item.properties.dominantColorCode
                            : "#ffffff",
                          backgroundImage:`url("https://mlca6kbxnopy.i.optimole.com/w:320/h:200/q:85/rs:fit/${item.properties?.curatedImage?item.properties?.curatedImage:item.properties?.image}")`
                         }}
                      > </div>
                      :
                      <div className="card-image"
                        style={{
                          backgroundColor: item.properties.dominantColorCode
                            ? item.properties.dominantColorCode
                            : "#ffffff",
                          backgroundImage:`url("https://mlca6kbxnopy.i.optimole.com/w:320/h:200/q:85/rs:fit/${item.properties?.curatedImage?item.properties?.curatedImage:item.properties?.image}")`
                         }}
                      > </div>
                      // <div className="flex-center" style={{ minHeight: "180px" }}>
                      //   {
                      //     item.properties.curatedImage ?
                      //       <img src={item.properties.curatedImage} style={{ maxHeight: "180px", maxWidth: "100%" }} loading="eager" />
                      //       :
                      //       <img src={"https://logo.clearbit.com/" + item.properties.url + "?size=800"} style={{ maxHeight: "180px", maxWidth: "100%" }} onError={(e) => { e.target.onerror = null; e.target.src = item.properties.image.replace(/ /g, "%20") }} loading="eager" />
                      //   }
                      // </div>
                  }
                </div> */}

                  <div
                    className={`${
                      this.props.from !== undefined &&
                      this.props.from === "wishlisted" &&
                      item.active === false &&
                      "offerExpContent"
                    } col-md-12 p-0 info-content`}
                    dir={lang === "AR" ? "rtl" : "ltr"}
                  >
                    {/* <div style={{display: "inline-block", paddingBottom: "8px"}}>
                  <div className="card-categoryName" style={uiConfig.config.whitelabel.campaign_card.card_tag}>
                      {item.category}
                  </div>
                </div> */}
                    <div
                      className="card-category-div"
                      dir={lang === "AR" ? "rtl" : "ltr"}
                    >
                      <div
                        className="card-category-name ellipsis"
                        style={
                          uiConfig.config.whitelabel.components.merchant_card
                            .cardCategoryColor
                            ? {
                                color:
                                  uiConfig.config.whitelabel.components
                                    .merchant_card.cardCategoryColor,
                                textTransform: "uppercase"
                              }
                            : {}
                        }
                        title={toTitleCase(item.category)}
                      >
                        {item.category}
                      </div>
                      <div style={{ display: "flex", flexDirection: "row",justifyContent:"center" , alignItems:"flex-start"  }}>
                        {item.properties.totalViews &&
                          config.hasTotalViews && (
                            <div
                              className="total-views"
                              style={{
                                borderRight: config.hasTasteMapScore  && item.properties.tasteMatchScore > 0
                                  ? "1px solid #E2E2E2"
                                  : ""
                              }}
                            >
                              {width >900 && (<div className= { !["all offers","nearby_offers"].includes(this.props.category) ?  "tooltip--total-views": "tooltip--total-views-right" }>
                                  {`Viewed ${item.properties.totalViews} times in 30 days`}
                                </div>
                              )}
                              <div style={{ marginRight: "2px" }}>
                                <Icon name="eye-empty" width="24" height="24" />
                              </div>
                              <div
                                style={{ marginBottom: "3px", color: "black" }}
                              >
                                {item.properties.totalViews}
                              </div>
                            </div>
                          )}
                        {item.properties.tasteMatchScore &&
                        item.properties.tasteMatchScore > 0 &&
                        config.hasTasteMapScore &&
                        this.props.item.itemType !== "PORTFOLIO_OFFERS" &&
                        this.props.item.itemType !== "FINANCIAL_PRODUCT" ? (
                          <div className="taste-match-div">
                            <div
                              className={
                                lang === "AR"
                                  ? "tooltip--score tooltip--score-arabic"
                                  : "tooltip--score"
                              }
                            >
                              <span className="firLine">
                                {lang === "AR"
                                  ? arabicTempText.tasteMatchScore
                                  : "Taste Match Score"}
                              </span>
                              <span
                                className="secLine"
                                style={{
                                  color: uiConfig.config.whitelabel.brandColor
                                }}
                              >
                                {lang === "AR"
                                  ? arabicTempText.knowMore
                                  : "Know more"}
                              </span>
                            </div>
                            <div style={{ width: "30px" ,marginTop:"1px"  }}>
                              <GaugeChart
                                id={`${item.id}-${itemId}`}
                                className="react-gauge"
                                arcWidth={0.3}
                                arcPadding={0.01}
                                hideText={true}
                                animate={false}
                                arcsLength={[
                                  item.properties.tasteMatchScore / 100,
                                  1 - item.properties.tasteMatchScore / 100
                                ]}
                                percent={item.properties.tasteMatchScore / 100}
                                needleColor="#303133"
                                colors={["#01C909", "#303133"]}
                              />
                            </div>
                            <div className="taste-match-text">
                              {item.properties.tasteMatchScore}%
                            </div>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div style={{ minHeight: width > 900 ? "130px" : "" }}>
                      <div
                        className={`info-div ${width < 900 ? "info-div-trucate" : ""}`}
                        style={
                          uiConfig.config.whitelabel.components.merchant_card
                            .cardTitleColor
                            ? {
                                color:
                                  uiConfig.config.whitelabel.components
                                    .merchant_card.cardTitleColor
                              }
                            : {}
                        }
                        title={item.name}
                      >
                         {item.name}
                      </div>
                      <div
                        className="info-desc"
                        style={
                          uiConfig.config.whitelabel.components.merchant_card
                            .cardDescColor
                            ? {
                                color:
                                  uiConfig.config.whitelabel.components
                                    .merchant_card.cardDescColor
                              }
                            : {}
                        }
                      >
                        {
                          // item.offers[0].name.length >= 35 ?
                          // <>
                          //   <span>{item.offers[0].name.substring(0,txtLen)}</span>
                          //   <span className="learn-more-text"  style={{color:uiConfig.config.whitelabel.brandColor}}>{lang==="AR"?arabicTempText.learnMore:"learn more"}</span>
                          //   {isArrowDisplayed&&lang!=="AR"&&<span><img src={uiConfig.config.whitelabel.clientName === 'maya' ? arrowRight : arrowRightBlue} alt="arrow" className="arrow-img"/></span>}
                          // </>
                          // :
                          <>
                            <span>
                              {truncateStr(
                                item.offers[0].name,
                                txtLen +
                                  (uiConfig.config.whitelabel.clientName !==
                                  "ADIB"
                                    ? 0
                                    : 11),
                                width
                              )}
                            </span>
                            {/* {uiConfig.config.whitelabel.clientName !== "ADIB" && width > 800 &&  <span className="learn-more-text" style={{ color: uiConfig.config.whitelabel.components.merchant_card.cardLearnMoreColor }}> {lang === "AR" ? arabicTempText.learnMore : "learn more"}</span>}
                        {isArrowDisplayed && lang !== "AR" && width > 800 && uiConfig.config.whitelabel.clientName !== "ADIB" && <span><img src={uiConfig.config.whitelabel.clientName === 'maya' ? arrowRight : arrowRightBlue} alt="arrow" className="arrow-img" /></span>} */}
                          </>
                        }
                      </div>
                    </div>
                    <div className="card-det">
                      {this.props.from !== undefined &&
                      this.props.from === "wishlisted" &&
                      item.active === false ? (
                        <div className="col-md-12 p-0 expired-info">
                          <img src={warningTriangle} alt="expired" />
                          <span style={{ paddingLeft: "3px" }}>Expired</span>
                        </div>
                      ) : (
                        <div className="col-md-12 p-0 expirees-info">
                          <span
                            style={{
                              fontWeight: "400",
                              paddingLeft: lang === "AR" && "5px",
                              color:
                                uiConfig.config.whitelabel.components
                                  .merchant_card.cardExpire
                            }}
                          >
                            {lang === "AR"
                              ? arabicTempText.expires
                              : "Expires : "}
                          </span>
                          <div
                            className={`"col-md-5 p-0 ${
                              lang === "EN" && "expireDate"
                            }"`}
                            style={{
                              paddingLeft: lang === "EN" && "3px",
                              color:
                                uiConfig.config.whitelabel.components
                                  .merchant_card.cardTitleColor,
                              fontWeight: "700"
                            }}
                          >
                            {lang === "AR"
                              ? formatDateProfileMonthArabic(
                                  item.offers[0].validTo
                                )
                              : this.renderDateField(item.offers[0].validTo)}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </a>
              </div>
            </a>
          </div>
        )}
      </>
    );
  }
}
